import { forwardRef, useEffect, useState } from 'react';
// @mui
import {
  Container,
  Dialog,
  Slide,
} from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import {
  InitJobPosting,
} from './init';
import {
  DirectJobPosting,
} from './direct';
import {
  PasteJobPosting,
} from './paste';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// ----------------------------------------------------------------------

export default function JobPostingDialog({ jobPost, isOpen, isEdit, editJobPost, closeDialog, reload, toggleDialog }) {
  const smUp = useResponsive('up', 'sm');
  const [postingMode, setPostingMode] = useState('');

  useEffect(() => {
    if (!jobPost?.id || ['position-set'].includes(jobPost?.status)) {
      setPostingMode('init');
    } else if (['method-direct', 'position-set', 'detail-position-set', 'context-set', 'monthly-budget-set', 'task-set'].includes(jobPost?.status)) {
      setPostingMode('direct');
    } else if (['method-paste', 'external-link-set', 'write-requested'].includes(jobPost?.status)) {
      setPostingMode('paste');
    } else {
      setPostingMode('direct');
    }
  }, [jobPost, isEdit]);

  const directToInit = () => {
    setPostingMode('init');
  }

  return (
    <Dialog fullScreen open={isOpen} onClose={closeDialog} TransitionComponent={Transition}>
      <Container sx={{ mt: smUp ? 5 : 0 }}>
        {postingMode === 'init' && (
          // select position & method
          <InitJobPosting
            jobPost={jobPost}
            reload={reload}
            close={closeDialog}
          />
        )}
        {postingMode === 'direct' && (
          <DirectJobPosting
            prevForm={directToInit}
            jobPost={jobPost}
            reload={reload}
            isEdit={isEdit}
            editJobPost={editJobPost}
            close={closeDialog}
            toggleDialog={toggleDialog}
          />
        )}
        {postingMode === 'paste' && (
          <PasteJobPosting
            prevForm={directToInit}
            jobPost={jobPost}
            reload={reload}
            isEdit={isEdit}
            toggleDialog={toggleDialog}
            close={closeDialog}
          />
        )}
        {postingMode === 'wrong' && (
          <div>잘못된 접근입니다</div>
        )}
      </Container>
    </Dialog>
  )
}
